module.exports = __webpack_public_path__ + "media/react/components/Chat/ChatDiscussion/assets/videocamera-3804ddda51dd8ed6f987666788a497d5.svg";